import React, { useEffect, useState, useContext } from 'react';
import { Helmet } from 'react-helmet';
import Page1 from './Part1';
import Part2 from '../Component/Home/Part2';
import { HomeContext } from '../Context/HomeContext';
import { useHomeDataLoader } from '../Hook/useHomeDataLoader';
import HeaderSlider from '../Component/Home/Part3';
import Feature from '../Component/Home/Part4.';
import Part5 from '../Component/Home/Part5';
import SubscribeBox from '../Component/Home/Subscribe';
import AdBlockHorizontalMultiplex from '../Component/Ads/AdBlockHorizontalMultiplex';
import AdBlockHorizontal from '../Component/Ads/AdBlockHorizontal';

export default function Home() {
  const { homeData } = useContext(HomeContext);
  const [metaTags, setMetaTags] = useState([]);

  useHomeDataLoader();

  useEffect(() => {
    if (homeData?.metaTags) {
      const doc = new DOMParser().parseFromString(homeData.metaTags, 'text/html');
      const tags = Array.from(doc.head.children);
      setMetaTags(tags);
    }
  }, [homeData]);

  const getMetaContent = (attr, value) => {
    const tag = metaTags.find(t => t.getAttribute(attr) === value);
    return tag?.getAttribute('content') || '';
  };

  return (
    <>
      <Helmet>
        <title>{getMetaContent('name', 'title') || 'Clever Coverage'}</title>
        <meta name="title" content={getMetaContent('name', 'title')} />
        <meta name="description" content={getMetaContent('name', 'description') || 'Explore trending fun stories, games, humor and creativity with Clever Coverage.'} />
        <meta name="keywords" content={getMetaContent('name', 'keywords') || 'fun, humor, blogs, entertainment, stories, games'} />

        <meta property="og:type" content={getMetaContent('property', 'og:type') || 'website'} />
        <meta property="og:url" content={getMetaContent('property', 'og:url') || 'https://www.funfillia.com'} />
        <meta property="og:title" content={getMetaContent('property', 'og:title')} />
        <meta property="og:description" content={getMetaContent('property', 'og:description')} />
        <meta property="og:image" content={getMetaContent('property', 'og:image')} />

        <meta name="twitter:card" content={getMetaContent('name', 'twitter:card') || 'summary_large_image'} />
        <meta name="twitter:title" content={getMetaContent('name', 'twitter:title')} />
        <meta name="twitter:description" content={getMetaContent('name', 'twitter:description')} />
        <meta name="twitter:image" content={getMetaContent('name', 'twitter:image')} />

        <link rel="canonical" href="https://www.funfillia.com" />
      </Helmet>
      <HeaderSlider/>

      <AdBlockHorizontalMultiplex/>

      <Page1 />
      <Part2 />
      <Part5/>

      <AdBlockHorizontal />

      <Feature/>
      <SubscribeBox/>
     
    </>
  );
}
